module.exports = __webpack_public_path__ + "static/media/login_reposit.0b205670.svg";